import { lazy, Suspense, type ReactElement } from "react";

import type { SmartGridProps } from "./props";
import "./LazySmartGrid.css";

const Loaded = lazy(() => import("./SmartGrid"));

/**
 * The SmartGrid loaded on first use: AG Grid is not part of the shell bundle (route-level code splitting, like the entry
 * grid). A skeleton of the table shows while the chunk loads.
 */
export function LazySmartGrid<T extends object>(props: SmartGridProps<T>): ReactElement {
  const Grid = Loaded as unknown as (props: SmartGridProps<T>) => ReactElement;
  return (
    <Suspense
      fallback={
        <div
          className="positive-sg-fallback"
          // A named, busy region (an aria-label on a plain div is prohibited: axe aria-prohibited-attr).
          role="region"
          aria-busy="true"
          aria-label={props.accessibleName}
          data-testid={props["data-testid"]}
        >
          {Array.from({ length: 4 }, (_, index) => (
            <span key={index} className="positive-sg-skeleton" />
          ))}
        </div>
      }
    >
      <Grid {...props} />
    </Suspense>
  );
}
